import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';

import { setScreenInfo as setStoreScreenInfo } from 'store/global/actions';
import { selectScreenInfo } from 'store/global/selectors';

import { RESIZE_THROTTLE_MS } from './constants';
import { calculateScreenInfo, getCurrentWidthAndHeight } from './utils';

const useWindowResize = () => {
  const dispatch = useDispatch();

  const [widthAndHeight, setWidthAndHeight] = useState(getCurrentWidthAndHeight());
  const [screenInfo, setScreenInfo] = useState(calculateScreenInfo(window.innerWidth));

  const storeScreenInfo = useSelector(selectScreenInfo);

  useEffect(() => {
    const onResize = _.throttle(() => {
      const [windowWidth, windowHeight] = getCurrentWidthAndHeight();

      setWidthAndHeight([windowWidth, windowHeight]);
      setScreenInfo(calculateScreenInfo(windowWidth));
    }, RESIZE_THROTTLE_MS);

    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
      onResize.cancel();
    };
  }, []);

  useEffect(() => {
    if (_.isEqual(screenInfo, storeScreenInfo)) {
      return;
    }

    dispatch(setStoreScreenInfo(screenInfo));
  }, [storeScreenInfo, screenInfo, dispatch]);

  return widthAndHeight;
};

export default useWindowResize;
